import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { CheckoutProvider } from "./CheckoutContext";
import CheckoutTabs from "./CheckoutTabs";

export default function CheckoutLayout() {
  return (
    <CheckoutProvider>
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <CheckoutTabs lockFuture />
        <Outlet />
      </Box>
    </CheckoutProvider>
  );
}